import BaseSecondaryStickyView from "scripts/views/baseSecondaryStickyNavView";
import templateModulesPageNav from "templates/modulesPageNav.hbs";

class ModulesPageNavView extends BaseSecondaryStickyView {
  get template() {
    return templateModulesPageNav;
  }

  shouldStick() {
    return true;
  }
}

export default ModulesPageNavView;
